import { render, staticRenderFns } from "./SchoolManagementForAdminEdit.vue?vue&type=template&id=72223c18"
import script from "./SchoolManagementForAdminEdit.vue?vue&type=script&lang=js"
export * from "./SchoolManagementForAdminEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports